import { render } from "./VacuumCooling.vue?vue&type=template&id=44bf3974"
import script from "./VacuumCooling.vue?vue&type=script&lang=js"
export * from "./VacuumCooling.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/bime-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__